// @ts-nocheck
/* Verbatim port of v1 router/context/SidebarPositionContext.js. */
import { createContext, useState, useEffect, useCallback, useContext } from 'react';

export const SidebarPositionContext = createContext({
  position: 'left',
  setPosition: () => {},
});

const STORAGE_KEY = 'sidebarPosition';

export const SidebarPositionProvider = ({ children }) => {
  const [position, setPositionState] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored === 'right' ? 'right' : 'left';
    } catch (e) {
      return 'left';
    }
  });

  const applyBodyClass = useCallback((pos) => {
    if (typeof document === 'undefined') return;
    const body = document.body;
    if (pos === 'right') {
      body.classList.add('sidebar-position-right');
      body.classList.remove('sidebar-position-left');
    } else {
      body.classList.add('sidebar-position-left');
      body.classList.remove('sidebar-position-right');
    }
  }, []);

  useEffect(() => {
    applyBodyClass(position);
    try {
      localStorage.setItem(STORAGE_KEY, position);
    } catch (e) {}
  }, [position, applyBodyClass]);

  const setPosition = useCallback((pos) => {
    setPositionState(pos === 'right' ? 'right' : 'left');
  }, []);

  return (
    <SidebarPositionContext.Provider value={{ position, setPosition }}>
      {children}
    </SidebarPositionContext.Provider>
  );
};

export const useSidebarPosition = () => useContext(SidebarPositionContext);
